export function NumberInput({
  labelText,
  placeholderText,
  name,
  register,
  isRequired,
  errors,
  errorMsg,
  min,
  max,
  isInSubGrid,
  disabled,
  valueOfRel,
  ...rest
}) {

  const safeMin = min !== undefined ? Math.max(0, min) : 0;

  return (
    <>
      <div
        className={`flex flex-col min-w-[236px] md:min-w-[276px] lg:min-w-[276px] min-h-[76px] ${
          isInSubGrid ? "mt-4" : "mt-8"
        }`}
      >
        <label
          className={`pb-3 ${
            valueOfRel && valueOfRel === true && errors[name] && isRequired
              ? "text-error-color"
              : ""
          } ${
            valueOfRel === undefined && errors[name] && isRequired
              ? "text-error-color"
              : ""
          } ${valueOfRel === false ? "text-disabled-color pointer-events: none" : ""}`}
        >
          {labelText}
          {isRequired ? "*" : ""}
        </label>

         <input
           type="number"
           min={safeMin}
           max={max}
           placeholder={placeholderText}
           name={name}
           disabled={valueOfRel != undefined && valueOfRel === false}
           {...register(name, {
             required:
               valueOfRel != undefined
                 ? isRequired && valueOfRel === true
                 : isRequired,
             min: safeMin,
             max: max,
             validate: (value) => Number(value) >= 0 || "no-negative",
           })}
           onKeyDown={(e) => {
             if (e.key === "-" || e.key === "e") {
               e.preventDefault();
             }
           }}
          onInput={(e) => {
					if (Number(e.target.value) < 0) e.target.value = 0;
          }}
           className={`border-[1px] rounded-md p-4 text-xs ${
             valueOfRel && valueOfRel === true && errors[name] && isRequired
               ? "border-error-color placeholder-error-color text-error-color"
               : ""
           } ${
             valueOfRel === undefined && errors[name] && isRequired
               ? "border-error-color placeholder-error-color text-error-color"
               : ""
           }`}
         />

         {(valueOfRel === undefined || valueOfRel === true) &&
         errors[name]?.type === "required" && (
          <div className="mt-1.5 font-bold text-xs" data-required="true">
            Campo Obbligatorio
          </div>
        )}
        {(valueOfRel === undefined || valueOfRel === true) &&
         errors[name]?.type === "min" && (
          <div className="mt-1.5 font-bold text-xs">
            Questo campo deve avere un valore minimo di {safeMin}
          </div>
        )}
        {(valueOfRel === undefined || valueOfRel === true) &&
         errors[name]?.type === "max" && (
          <div className="mt-1.5 font-bold text-xs">
            Questo campo deve avere un valore massimo di {max}
          </div>
        )}
        {(valueOfRel === undefined || valueOfRel === true) &&
         errors[name]?.type === "validate" && (
          <div className="mt-1.5 font-bold text-xs">
            Non sono ammessi numeri negativi
          </div>
        )}
      </div>
    </>
  );
}